<p-tabView class="tabview" (onChange)="onSelect()">
    <p-tabPanel header="הגדרות אוטומציה" headerStyleClass="tabview__header" class="tabpanel__menu">
        <div class="card tabpanel__card" (click)="goTemplates()">
            <div class="card__image card__image-sms"></div>
            <h2 class="card__title">הודעות סמס אוטומטיות</h2>
            <p class="card__details">תזכורות על התורים, ימי-הולדת, הודעה בקביעה או ביטול תור, תודה שביקרת וכו</p>
        </div>

        <div class="card tabpanel__card">
            <div class="card__tape">בקרוב</div>
            <div class="card__image card__image-calendar"></div>
            <h2 class="card__title">סוף חודש אוטומטי</h2>
            <p class="card__details">בקרוב: שליחת סיכומי קופה אוטומטיים לרו"ח, סיכום פעילות חודשי לבעל העסק ועוד</p>
        </div>

        <div class="card tabpanel__card">
            <div class="card__tape">בקרוב</div>
            <div class="card__image card__image-retention"></div>
            <h2 class="card__title">שימור לקוחות</h2>
            <p class="card__details">בקרוב: הקפצה אוטומטית של לקוחות שהפסיקו להגיע לצורך פנייה שיווקית</p>
        </div>

        <div class="card tabpanel__card">
            <div class="card__tape">בקרוב</div>
            <div class="card__image card__image-customers"></div>
            <h2 class="card__title">סיווג לקוחות אוטומטי</h2>
            <p class="card__details">בקרוב: ניתוח אוטומטי של הלקוחות לקבוצות : חדשים, קבועים, מועדפים, נוטשים ועוד</p>
        </div>
    </p-tabPanel>

    <p-tabPanel header="SMS דוחות" headerStyleClass="tabview__header">
        <app-reportssms></app-reportssms>
    </p-tabPanel>
</p-tabView>
